import { useGetExerciseOptions } from '../../../../redux/api/exerciseConfigAPI';
import { IProgramSetItem } from '../../../../types/interfaces/program-set-item';
import { ITrainingSetItem } from '../../../../types/interfaces/training-set-item';
import { orderOptions } from '../../../../utils/training/set-utils';
import { SetGroupEditTableMode, SetGroupFieldName } from '../interfaces';

export function useSetListEditComponent(
  setItem: IProgramSetItem | ITrainingSetItem,
  mode: SetGroupEditTableMode,
) {
  const { data: exerciseOptions } = useGetExerciseOptions();
  const setItemsFieldName = SetGroupFieldName[mode].optionsFieldName;

  const orderedOptions =
    (setItem?.[setItemsFieldName] &&
      exerciseOptions &&
      orderOptions(setItem?.[setItemsFieldName], exerciseOptions)) ||
    [];

  return { exerciseOptions, orderedOptions };
}
